<template>
  <select required @change="select" v-model="selectedOption">
    <option disabled="disabled" selected="selected" value="">{{ translate('lblSelect') }}</option>
    <option v-for="option in _options" :key="option.id" :value="option" :selected="option.selected">
      {{ option.label }}
    </option>
  </select>
</template>

<script>
/* eslint-disable no-underscore-dangle */
export default {
  data: () => ({
    // eslint-disable-next-line vue/no-reserved-keys
    _options: null,
    selectedOption: '',
  }),
  props: {
    questionId: String,
    options: Array,
  },
  methods: {
    select() {
      // eslint-disable-next-line no-param-reassign
      this._options.forEach((option) => delete option.selected);
      this.selectedOption.selected = true;
      this.$emit('change', this._options);
    },
  },
  watch: {
    questionId() {
      // does not fire for the first question (or last, if going back)
      this._options = this.options;
      this.selectedOption = this._options.filter((o) => o.selected)[0] ?? '';
    },
  },
  created() {
    // fires only for the first question (or last, if going back)
    this._options = this.options;
    this.selectedOption = this._options.filter((o) => o.selected)[0] ?? '';
  },
};
</script>

<style lang="scss">
.kws-quiz-question {
  select {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 2.625rem;
    padding-block: 0;
    padding-inline: .625rem 1.875rem;
    border: .0625rem solid #fff;
    border-radius: 0;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiPiAgPGRlZnM+ICAgIDxwb2x5Z29uIGlkPSJ0ZXN0X2Fycm93LWEiIHBvaW50cz0iMS40MTYgLjQyNCA2IDUuMDMyIDEwLjU4NCAuNDI0IDEyIDEuODQgNiA3Ljg0IDAgMS44NCIvPiAgPC9kZWZzPiAgPHVzZSBmaWxsPSIjMjMzNzM3IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHhsaW5rOmhyZWY9IiN0ZXN0X2Fycm93LWEiLz48L3N2Zz4=);
    background-position: calc(100% - 10px) 50%;
    background-repeat: no-repeat;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0 0 rem(30px) 0;

    &:focus, &:hover {
      border-color: $color-kws-light-gray-100;
    }
  }

  html[dir=rtl] & select {
    background-position: 10px 50%;
  }

  @media (min-width: rem(664px)) {
    select {
      width: auto;
      min-width: rem(288px);
    }
  }
}
</style>
